// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

import { PlacementFrontend } from '@post-office/placements--post-office-team/rovo-nudge';

import { MessageFrontend as createMessageFrontendLiveNudgeDemoMessage } from '@post-office/message-template--live-nudge-demo-message/placements/in-app-v2/rovo-nudge';

import { MessageFrontend as createMessageFrontendLiveAndPersistedTestMessage } from '@post-office/message-template--live-and-persisted-test-message/placements/in-app-v2/rovo-nudge';

import { MessageFrontend as createMessageFrontendJiraBoardCatchUpRovoNudge } from '@post-office/message-template--jira-board-catch-up-rovo-nudge/placements/in-app-v2/rovo-nudge';

import { MessageFrontend as createMessageFrontendJiraBoardBacklogUpdateWorkSuggestions } from '@post-office/message-template--jira-board-backlog-update-work-suggestions/placements/in-app-v2/rovo-nudge';

import { withI18n } from './i18n';

import {
	type PlacementRendererStage,
	type NoProps,
} from '@post-office/placement-common-v2/create-placement/types';

import { type ComponentType } from 'react';

const messageFrontends = [
createMessageFrontendLiveNudgeDemoMessage({messageTemplateId: 'live-nudge-demo-message'}),
createMessageFrontendLiveAndPersistedTestMessage({messageTemplateId: 'live-and-persisted-test-message'}),
createMessageFrontendJiraBoardCatchUpRovoNudge({messageTemplateId: 'jira-board-catch-up-rovo-nudge'}),
createMessageFrontendJiraBoardBacklogUpdateWorkSuggestions({messageTemplateId: 'jira-board-backlog-update-work-suggestions'}),
]

export const RawPlacement: PlacementRendererStage<NoProps> = PlacementFrontend.createPlacementFrontendComponent({
				messageTemplates: messageFrontends
			});

export const Placement: ComponentType<Omit<NoProps, "ref"> & {
    ref?: unknown;
}> = withI18n(RawPlacement)

export const SSRPlacement: PlacementRendererStage<NoProps> = RawPlacement
